module.exports = __webpack_public_path__ + "static/media/mdi_circle-off-outline.5ba5e9e9.svg";